/* eslint-disable */
import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import { Container, Stack, TextField, Typography, Box, IconButton } from '@material-ui/core';
import { LoadingButton } from '@material-ui/lab';
import Divider from '@material-ui/core/Divider';
import Page from '../../../Page';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import services from '../Service';
import Button from "@material-ui/core/Button";
import { ToastContainer, toast } from 'react-toastify';
import Card from '@material-ui/core/Card';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import Paper from '@material-ui/core/Paper';
import CSVReader from 'react-csv-reader';
import permissionAuth from 'src/utils/permissionAuth';
import TokenDecoder from 'src/helpers/TokenDecoder';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import PropTypes from 'prop-types'
import { useTheme } from '@mui/material/styles'
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import _ from 'lodash';
import { CSVLink } from 'react-csv';
import SearchNotFound from '../../../SearchNotFound';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

export default function AddOperationCost(props) {

  const navigate = useNavigate();
  const screenCode = 'ADDOPERATIONCOST';
  const [isUploadButtonEnable, setIsUploadButtonEnable] = useState(true);
  const [isTableEnable, setIsTableEnable] = useState(true);
  const [farmersCSVData, setFarmersCSVData] = useState([]);
  const [isFileChosen, setIsFileChosen] = useState(false);
  const [fileInfo, setFileInfo] = useState({});
  const [operationCostBulkUpload, setOperationCostBulkUpload] = useState([]);
  const [operationCostBulkUploadNew, setOperationCostBulkUploadNew] = useState([]);
  const [Datevalue, setDateValue] = React.useState(new Date().setDate(new Date().getDate()));

  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false
  });

  const [formData, setFormData] = useState({
    date: new Date().toISOString().split('T', 1)
  });

  const [pageProps, setPageProps] = useState({
    editingID: 0,
    isEdit: false,
    submitButtonName: "Upload",
    pageheadername: "Operation Cost Bulk Upload"
  });

  const ProductSaveSchema = Yup.object().shape({
    date: Yup.date().min(1).min(1, 'Please Select Date').required('Date required')
  });

  const formik = useFormik({
    initialValues: {
      date: formData.date
    },

    validationSchema: ProductSaveSchema,
    onSubmit: (values) => {
      if (pageProps.isEdit > 0) {
        UpdateProduct(values, pageProps.editingID)
      } else {
        // trackPromise(saveHartiPrice());
        trackPromise(saveOperationCost());
      }

    },
  });

  const { handleSubmit } = formik;

  useEffect(() => {
    setOperationCostBulkUpload([]);
    setIsTableEnable(true);
    clearAll();
  }, [Datevalue]);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - operationCostBulkUpload.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  async function saveOperationCost() {
    if (operationCostBulkUploadNew.length > 0) {
      const hasInvalidCost = operationCostBulkUploadNew.some(item => isNaN(item.Cost));
    
    if (hasInvalidCost) {
      toast.error("Excel column data invalid");
      return;
    }

      var res = await services.saveOperationCost(operationCostBulkUploadNew);
      if (res.statusCode == 'Success') {
        toast.success(res.message);
        clearAll();
      }
      else {
        toast.error(res.message);
      }
    }
    else {
      toast.error("Please select a correct file.");
    }
  }
  const isFutureDateDisabled = (date) => {
    return date > new Date();
  };
  async function assginMarket(data, type) {

    const requiredColumns = ["description", "alaveddy", "bandarwela", "boralanda", "hanguranketa", "kilinochchi", "nedunkeni", "norochcholei", "nuwaraEliya", "ruwanwella", "sigiriya", "thambuththegama", "thanamalwila", "thispane", "wattala"];

    const uploadedColumns = Object.keys(data[0]);
    const missingColumns = requiredColumns.filter(col => !uploadedColumns.includes(col));

    if (missingColumns.length > 0) {
      toast.error("CSV Template is not valid");
      setIsTableEnable(true);
      return;
    }

    if (type.type === "text/csv") {
      const factoryIDMapping = {
        Alaveddy: 26,
        Bandarwela: 16,
        Boralanda: 21,
        Hanguranketa: 19,
        Kilinochchi: 25,
        Nedunkeni: 29,
        Norochcholei: 17,
        NuwaraEliya: 13,
        Ruwanwella: 28,
        Sigiriya: 27,
        Thambuththegama: 18,
        Thanamalwila: 15,
        Thispane: 20,
        Wattala: 1
      };
      setOperationCostBulkUpload([]);
      setOperationCostBulkUploadNew([]);

      // const formatMoney = (value) => {
      //   if (value === null || value === undefined || value === "") {
      //     return '0.00';
      //   }

      //   return parseFloat(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      // };

      const formatMoney = (value) => {
        if (value === null || value === undefined || value === "") {
          return '0.00';
        }
        const numberValue = parseFloat(value);
        if (isNaN(numberValue) || numberValue < 0) {
          return value;
        }
        return numberValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      };
      
      let datarest = await Promise.all(data.map(async data => {
        // const invalidColumns = requiredColumns.slice(1).filter(col => {
        //   const value = data[col];
        //   return  !(/^[0-9]+$|^$/.test(value)) || parseFloat(value) < 0;
        // });
        // if (invalidColumns.length > 0) {
        //   setIsTableEnable(false);
        // }
        var operationCostDetails = {
          //date: new Date(Datevalue),
          Description: data.description,
          Alaveddy: formatMoney(data.alaveddy),
          Bandarwela: formatMoney(data.bandarwela),
          Boralanda: formatMoney(data.boralanda),
          Hanguranketa: formatMoney(data.hanguranketa),
          Kilinochchi: formatMoney(data.kilinochchi),
          Nedunkeni: formatMoney(data.nedunkeni),
          Norochcholei: formatMoney(data.norochcholei),
          NuwaraEliya: formatMoney(data.nuwaraEliya),
          Ruwanwella: formatMoney(data.ruwanwella),
          Sigiriya: formatMoney(data.sigiriya),
          Thambuththegama: formatMoney(data.thambuththegama),
          Thanamalwila: formatMoney(data.thanamalwila),
          Thispane: formatMoney(data.thispane),
          Wattala: formatMoney(data.wattala),
        }
        const newObject = Object.keys(operationCostDetails)
          .filter(key => key !== 'date' && key !== 'createdBy' && key !== 'Description')
          .map(key => ({
            date: new Date(Datevalue),
            Description: data.description,
            FactoryName: key,
            Cost: parseFloat(operationCostDetails[key].replace(/,/g, '')),
            FactoryID: factoryIDMapping[key],
            createdBy: parseInt(TokenDecoder.getUserIDFromToken())
          }));
        setOperationCostBulkUpload(operationCostBulkUpload => [...operationCostBulkUpload, operationCostDetails]);
        setOperationCostBulkUploadNew(newObject);
        setIsTableEnable(false);
      }));

      var errorList = [];
      datarest.map((itemx) => {
        if (itemx != undefined) {
          errorList.push(itemx);
        }
      })
      setFarmersCSVData(errorList);
    }

    else {
      toast.error(type.name + " is not valid . please select a CSV file.");
      setTimeout(() => {
      }, 3000);
    }
  }

  // function duplicateCheck() {
  //   let newRes = _.cloneDeep(hartiBulkUpload);
  //   var result = [];
  //   var duplicates = [];
  //   newRes.forEach(x => {

  //     var duplicateMarket = result.find(y => y.marketCode === x.marketCode && y.productCode === x.productCode);
  //     if (duplicateMarket != undefined) {
  //       duplicates.push(duplicateMarket);
  //     }
  //     result.push(x);
  //   });
  //   return duplicates;
  // }

  async function clearAll() {
    var operationCostDetails = {
      Description: "",
      Alaveddy: 0,
      Bandarwela: 0,
      Boralanda: 0,
      Hanguranketa: 0,
      Kilinochchi: 0,
      Nedunkeni: 0,
      Norochcholei: 0,
      NuwaraEliya: 0,
      Ruwanwella: 0,
      Sigiriya: 0,
      Thambuththegama: 0,
      Thanamalwila: 0,
      Thispane: 0,
      Wattala: 0,
    }

    setOperationCostBulkUpload([operationCostDetails]);
    setOperationCostBulkUploadNew([]);
    setIsFileChosen(false);
    setIsUploadButtonEnable(true);
    setIsTableEnable(true)
    document.querySelector('.csv-input').value = '';

  }

  const papaparseOptions = {
    header: true,
    dynamicTyping: false,
    quoteChar: '"',
    skipEmptyLines: true,
    parseNumbers: true,
    transformHeader: header => header.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
      return index === 0 ? word.toLowerCase() : word.toUpperCase();
    }).replace(/\s+/g, '')
  };

  const handleForce = (data, fileInfo) => {

    if (farmersCSVData != null) {
      setIsFileChosen(true);
      setFileInfo(fileInfo);
      assginMarket(data, fileInfo);
      confirmUpload(data, fileInfo);
    }
  }

  function confirmUpload(data, fileInfo) {
    setFarmersCSVData(data);
  }

  useEffect(() => {
    getPermissions();
  }, []);

  async function getPermissions() {
    var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWADDOPERATIONCOST');

    if (isAuthorized === undefined) {
      navigate('/404');
    }

    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
    });
  }

  const csvHeaders = [
    { label: "Description", key: "Description" },
    { label: "Alaveddy", key: "Alaveddy" },
    { label: "Bandarwela", key: "Bandarwela" },
    { label: "Boralanda", key: "Boralanda" },
    { label: "Hanguranketa", key: "Hanguranketa" },
    { label: "Kilinochchi", key: "Kilinochchi" },
    { label: "Nedunkeni", key: "Nedunkeni" },
    { label: "Norochcholei", key: "Norochcholei" },
    { label: "NuwaraEliya", key: "NuwaraEliya" },
    { label: "Ruwanwella", key: "Ruwanwella" },
    { label: "Sigiriya", key: "Sigiriya" },
    { label: "Thambuththegama", key: "Thambuththegama" },
    { label: "Thanamalwila", key: "Thanamalwila" },
    { label: "Thispane", key: "Thispane" },
    { label: "Wattala", key: "Wattala" }
  ];

  const csvData = [
    {
      Description: "", Alaveddy: "", Bandarwela: "", Boralanda: "", Hanguranketa: "", Kilinochchi: "", Nedunkeni: "", Norochcholei: "", NuwaraEliya: "", Ruwanwella: "", Sigiriya: "", Thambuththegama: "", Thanamalwila: "", Thispane: "", Wattala: "",
    },
  ];

  const csvData2 = [
    {
      Description: "Operation Cost per kg", Alaveddy: "12", Bandarwela: "11", Boralanda: "10", Hanguranketa: "9", Kilinochchi: "8", Nedunkeni: "18", Norochcholei: "54", NuwaraEliya: "21", Ruwanwella: "11", Sigiriya: "9", Thambuththegama: "27", Thanamalwila: "12", Thispane: "79", Wattala: "81"
    },
  ];

  return (
    <>
      <LoadingComponent />
      <Page title="Operation Cost Bulk Upload  |  FAPS">
        <Container>
          <CommonPageHeader
            path="/dashboard"
            btname="Back"
            pageName={pageProps.pageheadername}
            leftButtonHidden={true}
          />
          <FormikProvider value={formik}>
            <ToastContainer
              position="bottom-right"
              pauseOnHover
            />
            <Form autoComplete="off"
              disabled={!(formik.isValid && formik.dirty)}
              noValidate onSubmit={handleSubmit}
            >
              <Stack spacing={2}>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      fullWidth
                      size="small"
                      label="Date *"
                      openTo="day"
                      type="Date"
                      views={['year', 'month', 'day']}
                      value={Datevalue}
                      shouldDisableDate={isFutureDateDisabled}
                      onChange={(newValue) => {
                        setDateValue(newValue);
                      }}
                      renderInput={(params) =>
                        <TextField
                          width="100"
                          size="small"
                          {...params}
                        />}
                    />
                  </LocalizationProvider>
                </Stack>
                <br />
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <Button variant="contained" color='secondary' component="span"
                    disabled={formik.values.groupID == 0 || formik.values.operationEntityID == 0 ? true : false}>
                    <CSVReader
                      label={isFileChosen ? 'File Chosen' : 'Choose File'}
                      inputStyle={{ display: 'none' }}
                      onFileLoaded={handleForce}
                      parserOptions={papaparseOptions}
                      inputId="react-csv-reader-input"
                      cssClass="csv-reader-input"
                    />
                  </Button>
                  {isFileChosen ? <span>{fileInfo.name}</span> : null}
                  <Button variant="contained" color='primary' component="span">
                    <CSVLink
                      data={csvData}
                      headers={csvHeaders}
                      style={{ color: 'white' }}
                      filename={"Operation Cost Bulk Template.csv"}
                    >
                      Template
                    </CSVLink>
                  </Button>
                  <Button variant="contained" color='primary' component="span">
                    <CSVLink
                      data={csvData2}
                      headers={csvHeaders}
                      style={{ color: 'white' }}
                      filename={"Operation Cost Bulk Sample Template.csv"}
                    >
                      Sample Data
                    </CSVLink>
                  </Button>
                </Stack>
                <br />
                <Divider variant="middle" />
                <br />
                {/* {duplicateCheck().length != 0 ?
                  <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                    <Typography variant="h7" gutterBottom>
                      Duplicate Operation Cost Count : {duplicateCheck().length}
                    </Typography>
                  </Stack> : null} */}
                {isTableEnable == false ?
                  <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                    <Card style={{ justifycontent: 'center', width: '85rem' }} >
                      <TableContainer component={Paper} >
                        <Table aria-label="simple table">
                          <TableHead>
                            <TableRow>
                              <TableCell align="center">Description</TableCell>
                              <TableCell align="center">Alaveddy</TableCell>
                              <TableCell align="center">Bandarwela</TableCell>
                              <TableCell align="center">Boralanda</TableCell>
                              <TableCell align="center">Hanguranketa</TableCell>
                              <TableCell align="center">Kilinochchi</TableCell>
                              <TableCell align="center">Nedunkeni</TableCell>
                              <TableCell align="center">Norochcholei</TableCell>
                              <TableCell align="center">NuwaraEliya</TableCell>
                              <TableCell align="center">Ruwanwella</TableCell>
                              <TableCell align="center">Sigiriya</TableCell>
                              <TableCell align="center">Thambuththegama</TableCell>
                              <TableCell align="center">Thanamalwila</TableCell>
                              <TableCell align="center">Thispane</TableCell>
                              <TableCell align="center">Wattala</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {(rowsPerPage > 0
                              ? operationCostBulkUpload.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                              : operationCostBulkUpload
                            ).map((row, index, array) => {
                              //const isDuplicate = array.findIndex((item) => item.marketName === row.marketName && item.productCode === row.productCode) !== index;
                              return (
                                <TableRow
                                  key={row.Description}
                                // style={{
                                //   backgroundColor: isDuplicate ? '#FFEBEE' : 'inherit'
                                // }}
                                >
                                  <TableCell align="center">
                                    {row.Description}
                                  </TableCell>
                                  <TableCell align="center">
                                    {row.Alaveddy}
                                  </TableCell>
                                  <TableCell align="center">
                                    {row.Bandarwela}
                                  </TableCell>
                                  <TableCell align="center">
                                    {row.Boralanda}
                                  </TableCell>
                                  <TableCell align="center">
                                    {row.Hanguranketa}
                                  </TableCell>
                                  <TableCell align="center">
                                    {row.Kilinochchi}
                                  </TableCell>
                                  <TableCell align="center">
                                    {row.Nedunkeni}
                                  </TableCell>
                                  <TableCell align="center">
                                    {row.Norochcholei}
                                  </TableCell>
                                  <TableCell align="center">
                                    {row.NuwaraEliya}
                                  </TableCell>
                                  <TableCell align="center">
                                    {row.Ruwanwella}
                                  </TableCell>
                                  <TableCell align="center">
                                    {row.Sigiriya}
                                  </TableCell>
                                  <TableCell align="center">
                                    {row.Thambuththegama}
                                  </TableCell>
                                  <TableCell align="center">
                                    {row.Thanamalwila}
                                  </TableCell>
                                  <TableCell align="center">
                                    {row.Thispane}
                                  </TableCell>
                                  <TableCell align="center">
                                    {row.Wattala}
                                  </TableCell>
                                </TableRow>
                              );
                            })}
                            {/* {emptyRows > 0 && (
                              <TableRow style={{ height: 53 * emptyRows }}>
                                <TableCell colSpan={6} />
                              </TableRow>
                            )} */}
                          </TableBody>

                          {/* <TableFooter>
                            <TableRow>
                              <TablePagination
                                rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                                colSpan={6}
                                count={operationCostBulkUpload.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                SelectProps={{
                                  inputProps: {
                                    'aria-label': 'rows per page',
                                  },
                                  native: true,
                                }}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                                ActionsComponent={TablePaginationActions}
                              />
                            </TableRow>
                          </TableFooter> */}
                        </Table>
                      </TableContainer>
                    </Card>
                  </Stack> : <SearchNotFound searchQuery="Operation Cost Bulk Upload" />}
                {isTableEnable == false ?
                  <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                    <LoadingButton
                      size="small"
                      type="button"
                      color='error'
                      variant="outlined"
                      disabled={pageProps.isEdit}
                      onClick={() => clearAll()}
                    >
                      Clear
                    </LoadingButton>
                    <LoadingButton
                      size="small"
                      type="submit"
                      color='secondary'
                      variant="outlined"
                      disabled={isTableEnable}
                    >
                      {pageProps.submitButtonName}
                    </LoadingButton>
                  </Stack> : null}
              </Stack>
            </Form>
          </FormikProvider>
        </Container>
      </Page >
    </>
  )
}